<button
  class="scroll-cue"
  type="button"
  [attr.aria-label]="ariaLabel"
  [attr.aria-pressed]="isBottom"
  [class.is-bottom]="isBottom"
  [class.is-multi]="sections > 1"
  (click)="onCueClick()">
  <span class="scroll-cue__icon" aria-hidden="true">
    <span
      *ngFor="let dot of dotItems; let index = index"
      class="scroll-cue__dot"
      [class.is-active]="activeIndex === index"></span>
  </span>
</button>
